import dprlogo from "./images/dprlogo.png";
import feed1 from "./images/feed1.png"; // Import other images properly
import feed2 from "./images/feed2.png";
import feed3 from "./images/feed3.png";
import download from "./images/about-2.jpg";
import feed4 from "./images/about11.png";

import NotificationIcon from "./images/notificationicon.png";
import SettingsIcon from "./images/settingsicon.png";

import project1 from "./images/project1.webp";
import project2 from "./images/project2.webp";
import project3 from "./images/project3.webp";
import project4 from "./images/project4.webp";
import projectt from "./images/Bnn.jpeg";
import projectt0 from "./images/Bnn1.jpeg";

import plan from "./images/plan.png";
import Aboutimage from "./images/Aboutimage.png";

import user_icon from "./images/usericon.png";
import projects1 from "./images/project1.png";
import projects2 from "./images/project2.png";
import projects3 from "./images/project3.png";
import projects6 from "./images/projects6.jpeg";
import projects7 from "./images/projects7.jpeg";

import projectmain from "./images/projectmain.png";

import client1 from "./images/1.png";
import client2 from "./images/2.png";
import client3 from "./images/3.png";
import client4 from "./images/4.png";
import client5 from "./images/5.png";
import client6 from "./images/5.png";

import floor1 from "./images/floor1.webp";

import dprwhite from "./images/dpr_white.png";

// sliders
import dprslide1 from "./images/dprslide1.png";
import dprslide2 from "./images/dprslide2.png";
import dprslide3 from "./images/dprslide3.png";

import backgroundImage from "./images/backgroundImage.png";
import backgroundImage1 from "./images/appp.jpg";
import backgroundImage2 from "./images/backgroundImage2.png";
import bannerbackground from "./images/bannerNN.jpg";

import mobileapp from "./images/mobb.png";

import vision from "./images/abb.jpg";
import mission from "./images/abb1.jpg";

import whychooseus1 from "./images/whychooseus1.png";
import whychooseus2 from "./images/whychooseus2.png";
import whychooseus3 from "./images/whychooseus3.png";

import aboutN from "./images/aboutN.jpg";
import aboutN1 from "./images/Aboutimage.png";

import testimonialN from "./images/rev1.jpg";
import testimonialN1 from "./images/rev2.jpg";

import blogcontent from "./images/blogcontent.jpg";
import blogbanner from "./images/blogbanner.jpg";
import singleblogauthor from "./images/singleblogauthor.png";
import mission1 from "./images/abb2.png";
import blog from "./images/blog.jpg";
import aboutUss from "./images/AboutUss.png";

// import home3 from './images/home3.png';
// import home4 from './images/home4.jpg';
// import home5 from './images/home5.jpg';
import rajiv from "./images/rajiv.jpg";

import project9 from "./images/project9.png";
import servicebannerone from "./images/servicebannerone.png";

import service1 from "./images/Services/service1.png";
import service2 from "./images/Services/service2.png";
import service3 from "./images/Services/service3.png";
import service4 from "./images/Services/service4.png";
import service5 from "./images/Services/service5.png";
import service6 from "./images/Services/service6.png";
import service7 from "./images/Services/service7.png";
import service8 from "./images/Services/service8.png";
import service9 from "./images/Services/service9.png";
import service10 from "./images/Services/service10.png";
import service11 from "./images/Services/service11.png";
import service12 from "./images/Services/service12.png";

//team
import agentsImage1 from "./images/Team/r1.png";
import agentsImage2 from "./images/Team/i1.png";
import agentsImage3 from "./images/Team/PP.png";

//client logos
import icon from "./images/IconLogos/ico (1).png";
import icon1 from "./images/IconLogos/ico (2).png";
import icon2 from "./images/IconLogos/ico (3).png";
import icon3 from "./images/IconLogos/ico (4).png";
import icon4 from "./images/IconLogos/ico (5).png";
import icon5 from "./images/IconLogos/ico (6).png";
import icon6 from "./images/IconLogos/ico (7).png";
import icon7 from "./images/IconLogos/ico (8).png";
import icon8 from "./images/IconLogos/ico (9).png";
import icon9 from "./images/IconLogos/ico (10).png";
import icon10 from "./images/IconLogos/ico (11).png";
import icon11 from "./images/IconLogos/ico (12).png";
import icon12 from "./images/IconLogos/ico (13).png";
import icon13 from "./images/IconLogos/ico (14).png";
import icon14 from "./images/IconLogos/ico (15).png";
import icon28 from "./images/IconLogos/ico (28).png";
import icon29 from "./images/IconLogos/ico (29).png";
import icon30 from "./images/IconLogos/ico (30).png";
import icon31 from "./images/IconLogos/ico (31).png";

//sellinggroup file

import g1 from "./images/dddd.png";
import g2 from "./images/aaaa.png";
import g3 from "./images/Apartement.png";

import dpr_brchure from "./PDF/DPR_Brochure.pdf";

import VamC1 from "./images/GalleryImages/VamshiC (1).jpg";
import VamC2 from "./images/GalleryImages/VamshiC (2).jpg";
import VamC3 from "./images/GalleryImages/VamshiC (3).jpg";
import VamC4 from "./images/GalleryImages/VamshiC (4).jpg";
import VamC5 from "./images/GalleryImages/VamshiC (5).jpg";
import VamC6 from "./images/GalleryImages/VamshiC (6).jpg";
import VamC7 from "./images/GalleryImages/VamshiC (7).jpg";
import VamC8 from "./images/GalleryImages/VamshiC (8).jpg";
import VamC9 from "./images/GalleryImages/VamshiC (9).jpg";
import VamC10 from "./images/GalleryImages/VamshiC (10).jpg";
import VamC11 from "./images/GalleryImages/VamshiC (11).jpg";
import VamC12 from "./images/GalleryImages/VamshiC (12).jpg";
import VamC13 from "./images/GalleryImages/VamshiC (13).jpg";
import VamC14 from "./images/GalleryImages/VamshiC (14).jpg";

import Tejase1 from "./images/GalleryImages/TejaseCR (1).jpg";
import Tejase2 from "./images/GalleryImages/TejaseCR (2).jpg";
import Tejase3 from "./images/GalleryImages/TejaseCR (3).jpg";
import Tejase4 from "./images/GalleryImages/TejaseCR (4).jpg";
import Tejase5 from "./images/GalleryImages/TejaseCR (5).jpg";
import Tejase6 from "./images/GalleryImages/TejaseCR (6).jpg";
import Tejase7 from "./images/GalleryImages/TejaseCR (7).jpg";
import Tejase8 from "./images/GalleryImages/TejaseCR (8).jpg";
import Tejase9 from "./images/GalleryImages/TejaseCR (9).jpg";
import Tejase10 from "./images/GalleryImages/TejaseCR (10).jpg";
import Tejase11 from "./images/GalleryImages/TejaseCR (11).jpg";
import Tejase12 from "./images/GalleryImages/TejaseCR (12).jpg";
import Tejase13 from "./images/GalleryImages/TejaseCR (13).jpg";
import Tejase14 from "./images/GalleryImages/TejaseCR (14).jpg";
import Tejase15 from "./images/GalleryImages/TejaseCR (15).jpg";
import Tejase16 from "./images/GalleryImages/TejaseCR (16).jpg";
import Tejase17 from "./images/GalleryImages/TejaseCR (17).jpg";
import Tejase18 from "./images/GalleryImages/TejaseCR (18).jpg";
import Tejase19 from "./images/GalleryImages/TejaseCR (19).jpg";
import Tejase20 from "./images/GalleryImages/TejaseCR (20).jpg";
import Tejase21 from "./images/GalleryImages/TejaseCR (21).jpg";
import Tejase22 from "./images/GalleryImages/TejaseCR (22).jpg";
import Tejase23 from "./images/GalleryImages/TejaseCR (23).jpg";
import Tejase24 from "./images/GalleryImages/TejaseCR (24).jpg";
import Tejase25 from "./images/GalleryImages/TejaseCR (25).jpg";
import Tejase26 from "./images/GalleryImages/TejaseCR (26).jpg";
import Tejase27 from "./images/GalleryImages/TejaseCR (27).jpg";
import Tejase28 from "./images/GalleryImages/TejaseCR (28).jpg";
import Tejase29 from "./images/GalleryImages/TejaseCR (29).jpg";
import Tejase30 from "./images/GalleryImages/TejaseCR (30).jpg";
import Tejase31 from "./images/GalleryImages/TejaseCR (31).jpg";
import Tejase32 from "./images/GalleryImages/TejaseCR (32).jpg";
import Tejase33 from "./images/GalleryImages/TejaseCR (33).jpg";
import Tejase34 from "./images/GalleryImages/TejaseCR (34).jpg";
import Tejase35 from "./images/GalleryImages/TejaseCR (35).jpg";
import Tejase36 from "./images/GalleryImages/TejaseCR (36).jpg";
import Tejase37 from "./images/GalleryImages/TejaseCR (37).jpg";
import Tejase38 from "./images/GalleryImages/TejaseCR (38).jpg";
import Tejase39 from "./images/GalleryImages/TejaseCR (39).jpg";
import Tejase40 from "./images/GalleryImages/TejaseCR (40).jpg";
import Tejase41 from "./images/GalleryImages/TejaseCR (41).jpg";
import Tejase42 from "./images/GalleryImages/TejaseCR (42).jpg";
import Tejase43 from "./images/GalleryImages/TejaseCR (43).jpg";
import Tejase44 from "./images/GalleryImages/TejaseCR (44).jpg";
import Tejase45 from "./images/GalleryImages/TejaseCR (45).jpg";
import Tejase46 from "./images/GalleryImages/TejaseCR (46).jpg";
import Tejase47 from "./images/GalleryImages/TejaseCR (47).jpg";
import Tejase48 from "./images/GalleryImages/TejaseCR (48).jpg";
import Tejase49 from "./images/GalleryImages/TejaseCR (49).jpg";
import Tejase50 from "./images/GalleryImages/TejaseCR (50).jpg";
import Tejase51 from "./images/GalleryImages/TejaseCR (51).jpg";
import Tejase52 from "./images/GalleryImages/TejaseCR (52).jpg";
import Tejase53 from "./images/GalleryImages/TejaseCR (53).jpg";
import Tejase54 from "./images/GalleryImages/TejaseCR (54).jpg";

import IwaC1 from "./images/GalleryImages/iwaC (1).jpg";
import IwaC2 from "./images/GalleryImages/iwaC (2).jpeg";
import IwaC3 from "./images/GalleryImages/iwaC (3).jpeg";
import IwaC4 from "./images/GalleryImages/iwaC (4).jpeg";
import IwaC5 from "./images/GalleryImages/iwaC (5).jpeg";
import IwaC6 from "./images/GalleryImages/iwaC (6).jpeg";
import IwaC7 from "./images/GalleryImages/iwaC (7).jpeg";
import IwaC8 from "./images/GalleryImages/iwaC (8).jpeg";
import IwaC9 from "./images/GalleryImages/iwaC (9).jpeg";
import IwaC10 from "./images/GalleryImages/iwaC (10).jpeg";
import IwaC11 from "./images/GalleryImages/iwaC (11).jpeg";
import IwaC12 from "./images/GalleryImages/iwaC (12).jpeg";
import IwaC13 from "./images/GalleryImages/iwaC (13).jpeg";
import IwaC14 from "./images/GalleryImages/iwaC (14).jpeg";
import IwaC15 from "./images/GalleryImages/iwaC (15).jpeg";

import atm_icon from "./images/AmenitiesIcons/ATM_icon.png";
import badminton_icon from "./images/AmenitiesIcons/BadmintonCourt_icon.png";
import basketball_icon from "./images/AmenitiesIcons/BasketballCourt_icon.png";
import cctv_icon from "./images/AmenitiesIcons/CCTV_icon.png";
import carparking_icon from "./images/AmenitiesIcons/CarParking_icon.png";
import clubhouse_icon from "./images/AmenitiesIcons/ClubHouse_icon.png";
import elevator_icon from "./images/AmenitiesIcons/Elevator_icon.png";
import gym_icon from "./images/AmenitiesIcons/Gym_icon.png";
import indoorgames_icon from "./images/AmenitiesIcons/IndoorGames_icon.png";
import jogging_icon from "./images/AmenitiesIcons/JoggingTrack_icon.png";
import library_icon from "./images/AmenitiesIcons/Library_icon.png";
import power_icon from "./images/AmenitiesIcons/Power_icon.png";
import rainwater_icon from "./images/AmenitiesIcons/Rainwater_icon.png";
import sewage_icon from "./images/AmenitiesIcons/Sewage_icon.png";
import swimming_icon from "./images/AmenitiesIcons/SwimmingPool_icon.png";
import tennis_icon from "./images/AmenitiesIcons/Tennis_icon.png";
import water_icon from "./images/AmenitiesIcons/Water_icon.png";
import wifi_icon from "./images/AmenitiesIcons/Wifi_icon.png";
import user from "./images/user.png";
import blogsmalls from "./images/blogsmalll.png";
import revenuegrowth from "./images/revenuegrowth.png";
import employee from "./images/employee.png";
import transactionsuccess from "./images/transactionsuccess.png";
import mobileappbanner from "./images/mobileappbanner.jpg";
import durgamcheruvu from "./images/durgamcheruvu.webp";
import projectbanner from "./images/projectbanner.png";

import gallery1 from "./images/Gallery/gallery1.jpg";
import gallery2 from "./images/Gallery/gallery2.jpg";
import gallery3 from "./images/Gallery/gallery3.jpg";
import gallery4 from "./images/Gallery/gallery4.jpg";
import gallery5 from "./images/Gallery/gallery5.jpg";
import gallery6 from "./images/Gallery/gallery6.jpg";
import gallery7 from "./images/Gallery/gallery7.jpg";
import gallery8 from "./images/Gallery/gallery8.jpg";
import gallery9 from "./images/Gallery/gallery9.jpg";
import gallery10 from "./images/Gallery/gallery10.jpg";
import gallery11 from "./images/Gallery/gallery11.jpg";
import gallery12 from "./images/Gallery/gallery12.jpg";
import gallery13 from "./images/Gallery/gallery13.jpg";
import gallery14 from "./images/Gallery/gallery14.jpg";
import gallery15 from "./images/Gallery/gallery15.jpg";
import gallery16 from "./images/Gallery/gallery16.jpg";
import gallery17 from "./images/Gallery/gallery17.jpg";
import gallery18 from "./images/Gallery/gallery18.jpg";
import gallery19 from "./images/Gallery/gallery19.jpg";
import gallery20 from "./images/Gallery/gallery20.jpg";
import gallery21 from "./images/Gallery/gallery21.jpg";
import gallery22 from "./images/Gallery/gallery22.jpg";
import gallery23 from "./images/Gallery/gallery23.jpg";
import gallery24 from "./images/Gallery/gallery24.jpg";

// import gallery25 from './images/Gallery/gallery25.jpg';

import img1 from "./images/Gallery/29 (1).jpeg";
import img2 from "./images/Gallery/29 (2).jpeg";
import img3 from "./images/Gallery/29 (3).jpeg";
import img4 from "./images/Gallery/29 (4).jpeg";
import img5 from "./images/Gallery/29 (5).jpeg";
import img6 from "./images/Gallery/29 (6).jpeg";
import img7 from "./images/Gallery/29 (7).jpeg";
import img8 from "./images/Gallery/29 (8).jpeg";

import EMI from "./images/EMI.webp";

import blog2 from "./images/blog2.jpg";

//job portal images
import jobimage from "./images/jobimage.png";
import android from "./images/android.png";
import lenovo from "./images/lenovo.png";
import snap from "./images/snap.png";
import fb from "./images/fb.png";
import google from "./images/google.png";
import linkedin from "./images/linkedin.png";
import c from "./images/c.png";
import s from "./images/s.png";

// IT jobs
import job1 from "./images/job1.jpg";
import job2 from "./images/job2.jpg";
import job3 from "./images/job3.jpg";
import job4 from "./images/job4.jpg";
import job5 from "./images/job5.jpg";
import job6 from "./images/job6.jpg";

import girl1 from "./images/girl1.jpg";
import girl2 from "./images/girl2.jpg";

import office1 from "./images/office1.jpg";
import office2 from "./images/office2.jpg";

import backgroundImagesCareers from "./images/backgroundImagesCareers.jpg";


import tribujahs from './images/tribuja/tribhujahs.png'
import tribujalogo from './images/tribuja/tribhujalogo.png'
import landingpagebg from './images/tribuja/herobg.png'
import landingpagebg2 from './images/tribuja/herobg2.webp'

export const Tribuja = {
  tribujahs,tribujalogo,landingpagebg,landingpagebg2
}

export const JobDetailsPage = {
  backgroundImagesCareers,
};

export { backgroundImagesCareers };

export const BestCompanies = {
  office1,
  office2,
};

export { office1, office2 };

export const MillionsOfJobs = {
  girl1,
  girl2,
};

export { girl1, girl2 };

export const CareerFinder = {
  jobimage,
  android,
  lenovo,
  fb,
  snap,
  c,
  linkedin,
  google,
  s,
};

export { jobimage, android, lenovo, fb, snap, c, linkedin, google, s };

export const TrendingServices = {
  job1,
  job2,
  job3,
  job4,
  job5,
  job6,
};

export { job1, job2, job3, job4, job5, job6 };

export const Jobnova = {
  icon28,
  icon29,
  icon30,
  icon31,
};

export { icon28, icon29, icon30, icon31 };

export const GalleryGridOne = {
  gallery1,
  gallery2,
  gallery3,
};
export const GalleryGridTwo = {
  gallery4,
  gallery5,
  gallery6,
};
export const GalleryGridThree = {
  gallery7,
  gallery8,
  gallery9,
};
export const GalleryGridFour = {
  gallery13,
  gallery15,
  gallery17,
};
export const GalleryGridFive = {
  gallery10,
  gallery11,
  gallery12,
};

export const GalleryGridSix = {
  gallery14,
  gallery16,
  gallery18,
};

export const NewGallery = {
  img1,
  img2,
  img3,
  img4,
  img5,
  img6,
  img7,
  img8,
};

export {
  gallery1,
  gallery2,
  gallery3,
  gallery4,
  gallery5,
  gallery6,
  gallery7,
  gallery8,
  gallery9,
  gallery10,
  gallery11,
  gallery12,
  gallery13,
  gallery14,
  gallery16,
  gallery18,
  EMI,
};

export const counter = {
  revenuegrowth,
  employee,
  transactionsuccess,
};

export {
  dprlogo,
  feed1,
  feed2,
  feed3,
  download,
  feed4,
  NotificationIcon,
  SettingsIcon,
  mobileappbanner,
  durgamcheruvu,
  projectbanner,
  aboutUss,
  servicebannerone,
};

export {
  floor1,
  dprwhite,
  backgroundImage,
  mobileapp,
  backgroundImage1,
  backgroundImage2,
  bannerbackground,
  blogbanner,
  singleblogauthor,
  blogcontent,
  mission1,
  blog,
};

export {
  vision,
  mission,
  rajiv,
  projectmain,
  dpr_brchure,
  user_icon,
  blogsmalls,
  user,
  revenuegrowth,
  employee,
  transactionsuccess,
  blog2,
};

export const ProjectImagesNew = {
  projects1,
  projects2,
  projects3,
  projects6,
  projects7,
  project9,
  plan,
  Aboutimage,
};

export { whychooseus1, whychooseus2, whychooseus3 };

export const TabsIcons = {
  NotificationIcon,
  SettingsIcon,
};

export const AboutNew = {
  aboutN,
  aboutN1,
};

// export const HomeImages ={
//   home3,
//   home4,
//   home5
// }

export const Testimo = {
  testimonialN,
  testimonialN1,
};

export const ProjectsImages = {
  project1,
  project2,
  project3,
  project4,
  projectt,
  projectt0,
};

export const ClientLogos = {
  client1,
  client2,
  client3,
  client4,
  client5,
  client6,
};

export const SliderImages = {
  dprslide1,
  dprslide2,
  dprslide3,
};

export const ServiceImages = {
  service1,
  service2,
  service3,
  service4,
  service5,
  service6,
  service7,
  service8,
  service9,
  service10,
  service11,
  service12,
};

export const Team = {
  agentsImage1,
  agentsImage2,
  agentsImage3,
};

export const IconsLogos = {
  icon,
  icon1,
  icon2,
  icon3,
  icon4,
  icon5,
  icon6,
  icon7,
  icon8,
  icon9,
  icon10,
  icon11,
  icon12,
  icon13,
  icon14,
};

export const GImages = {
  g1,
  g2,
  g3,
};

export const ChannelPartnerImages = {
  projects1,
  projects2,
  projects3,
  projects6,
  projects7,
  project9,
};

export const Vamshiram = {
  VamC1,
  VamC2,
  VamC3,
  VamC4,
  VamC5,
  VamC6,
  VamC7,
  VamC8,
  VamC9,
  VamC10,
  VamC11,
  VamC12,
  VamC13,
  VamC14,
};

export const Tejase = {
  Tejase1,
  Tejase2,
  Tejase3,
  Tejase4,
  Tejase5,
  Tejase6,
  Tejase7,
  Tejase8,
  Tejase9,
  Tejase10,
  Tejase11,
  Tejase12,
  Tejase13,
  Tejase14,
  Tejase15,
  Tejase16,
  Tejase17,
  Tejase18,
  Tejase19,
  Tejase20,
  Tejase21,
  Tejase22,
  Tejase23,
  Tejase24,
  Tejase25,
  Tejase26,
  Tejase27,
  Tejase28,
  Tejase29,
  Tejase30,
  Tejase31,
  Tejase32,
  Tejase33,
  Tejase34,
  Tejase35,
  Tejase36,
  Tejase37,
  Tejase38,
  Tejase39,
  Tejase40,
  Tejase41,
  Tejase42,
  Tejase43,
  Tejase44,
  Tejase45,
  Tejase46,
  Tejase47,
  Tejase48,
  Tejase49,
  Tejase50,
  Tejase51,
  Tejase52,
  Tejase53,
  Tejase54,
};

export const Iwa = {
  IwaC1,
  IwaC2,
  IwaC3,
  IwaC4,
  IwaC5,
  IwaC6,
  IwaC7,
  IwaC8,
  IwaC9,
  IwaC10,
  IwaC11,
  IwaC12,
  IwaC13,
  IwaC14,
  IwaC15,
};

export const AmenIcons = {
  atm_icon,
  badminton_icon,
  basketball_icon,
  cctv_icon,
  carparking_icon,
  clubhouse_icon,
  elevator_icon,
  gym_icon,
  indoorgames_icon,
  jogging_icon,
  library_icon,
  power_icon,
  rainwater_icon,
  sewage_icon,
  swimming_icon,
  tennis_icon,
  water_icon,
  wifi_icon,
};
